import React, { useState, useEffect } from "react";
import { Main, Content } from "../../../components/Layout";
import { Col, Row } from "react-bootstrap";
import IcEditar from "../../../components/Svg/IcEditar";
import api from "../../../services/api";
import Accordion from "../../../components/Accordion";
import TabNotification from "../../../components/TabNotification";
import Checkbox from "../../../components/Checkbox";
import styleButton from "../../../components/Button/Button.module.css";
import { ModalConfirm } from "../../../components/Modal";
import Loading from "../../../components/Loading";
import { toast } from "react-toastify";
import useWrapper from "../../../hooks/useWrapper";
import Tooltip2 from "../../../components/Tooltip";

export default function CostCenter() {
  const { setbreadcrumb, config } = useWrapper();

  const [loadingPage, setLoadingPage] = useState(true);
  const [reload, setreload] = useState(false);

  const [costCenter, setcostCenter] = useState();
  useEffect(() => {
    api.get("cost-center", config).then(response => {
      let _cost_center = response.data;
      _cost_center = _cost_center.map(__category => {
        let _expensePlans = __category.expensePlan;
        _expensePlans.sort((a, b) => {
          return a.name.localeCompare(b.name);
        });
        return {
          ...__category,
          expensePlan: _expensePlans,
        };
      });
      _cost_center.sort((a, b) => {
        return a.name.localeCompare(b.name);
      });
      setcostCenter([
        {
          id: "receita",
          label: "Receita",
          show: true,
          costCenters: _cost_center.filter(e => e.type === "receita"),
        },
        {
          id: "despesa",
          label: "Despesa",
          show: true,
          costCenters: _cost_center.filter(e => e.type === "despesa"),
        },
      ]);
      setLoadingPage(false);
    });
    // config is recreated on every WrapperContext render; only re-fetch when `reload` changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload]);

  const createExpense = e => {
    if (!e.name) {
      setreload(!reload);
    } else if (!e.id) {
      api
        .post(
          "expense",
          {
            name: e.name,
            expense_plan_id: e.expense_plan_id,
            is_cac: e.is_cac,
          },
          config,
        )
        .then(() => {
          toast.success(`Nova Receita "${e.name}" criada com sucesso!`);
          setreload(!reload);
        });
    } else {
      api
        .put(
          `expense/${e.id}`,
          {
            name: e.name,
            expense_plan_id: e.expense_plan_id,
            is_cac: e.is_cac,
          },
          config,
        )
        .then(() => {
          toast.success(`Receita "${e.name}" editada com sucesso!`);
          setreload(!reload);
        });
    }
  };

  const createExpensePlan = e => {
    if (!e.name) {
      setreload(!reload);
    } else if (!e.id) {
      api
        .post(
          "expense-plan",
          {
            name: e.name,
            cost_center_id: e.cost_center_id,
          },
          config,
        )
        .then(() => {
          toast.success(`Novo Plano de Custo "${e.name}" criado com sucesso!`);
          setreload(!reload);
        });
    } else {
      api
        .put(
          `expense-plan/${e.id}`,
          {
            name: e.name,
            cost_center_id: e.cost_center_id,
          },
          config,
        )

        .then(() => {
          toast.success(`Plano de Custo "${e.name}" editado com sucesso!`);
          setreload(!reload);
        });
    }
  };

  const createCostCenter = e => {
    if (!e.name) {
      setreload(!reload);
    } else if (!e.id) {
      api
        .post(
          "cost-center",
          {
            name: e.name,
            type: e.type,
          },
          config,
        )
        .then(() => {
          toast.success(`Novo Centro de Custo "${e.name}" criado com sucesso!`);
          setreload(!reload);
        });
    } else {
      api
        .put(
          `cost-center/${e.id}`,
          {
            name: e.name,
            type: e.type,
          },
          config,
        )
        .then(() => {
          toast.success(`Centro de Custo "${e.name}" editado com sucesso!`);
          setreload(!reload);
        });
    }
  };

  const [deleteExpenseModal, setdeleteExpenseModal] = useState(null);
  const deleteExpense = () => {
    if (deleteExpenseModal) {
      api.delete(`expense/${deleteExpenseModal?.id}`, config).then(() => {
        setdeleteExpenseModal(null);
        setreload(!reload);
      });
    }
  };
  const [packagesTabActive, setpackagesTabActive] = useState("receita");

  useEffect(() => {
    setbreadcrumb([{ label: "Administrativo" }]);
  }, [setbreadcrumb]);

  return (
    <>
      {loadingPage ? (
        <Main>
          <Content>
            <Loading />
          </Content>
        </Main>
      ) : (
        <Main>
          {deleteExpenseModal && (
            <ModalConfirm
              show={deleteExpenseModal}
              title="Apagar Item"
              text={`Tem certeza que deseja apagar ${deleteExpenseModal.name}?`}
              confirm={deleteExpense}
              closeModal={() => {
                setdeleteExpenseModal(null);
              }}
              colorScheme="error"
            />
          )}
          <Content>
            <h2 className="mini-title">Gerenciar Centro de Custo</h2>
            <p className="small-label font-italic mb-3">
              Crie Centros de Custo, Planos de Conta e Contas atreladas para saber o destino dos seus gastos e
              recebimentos.
            </p>
            <TabNotification
              options={costCenter.map(__costcenter => ({
                ...__costcenter,
                label: `${__costcenter.label}s`,
                show: true,
              }))}
              setActive={setpackagesTabActive}
              active={packagesTabActive}
              init={null}
            />
            {costCenter.map((__costcenter, __costcenter_i) => (
              <>
                {packagesTabActive === __costcenter?.id && (
                  <>
                    <TabNotification.Body>
                      <Accordion>
                        {__costcenter.costCenters.map((__costcenters, __costcenters_i) => (
                          <Accordion.Item eventKey={`${__costcenter.id}.${__costcenters.id}`}>
                            <Accordion.Header
                              eventKey={!__costcenters.editable ? `${__costcenter.id}.${__costcenters.id}` : null}
                              style={__costcenter.editable ? { borderColor: "var(--color-primary" } : {}}
                            >
                              <div
                                className={styleButton.input_button_list}
                                data-edit={__costcenters.editable}
                                style={{ border: "none", padding: "0", height: "auto" }}
                              >
                                <div className="titleAccordion"></div>
                                <label style={{ cursor: "pointer" }}>
                                  {__costcenters.id ? <span>{__costcenters_i + 1}</span> : <span></span>}
                                  <input
                                    type="text"
                                    placeholder={`Novo Centro de Custo (${__costcenter.label})`}
                                    value={__costcenters.name}
                                    disabled={!__costcenters.editable}
                                    autoFocus
                                    style={!__costcenters.editable ? { pointerEvents: "none" } : {}}
                                    onChange={ev => {
                                      let _cost_center = [...costCenter];
                                      _cost_center[__costcenter_i].costCenters[__costcenters_i].name = ev.target.value;
                                      setcostCenter(_cost_center);
                                    }}
                                    onBlur={() => {
                                      let _cost_center = [...costCenter];
                                      createCostCenter({
                                        id: __costcenters.id,
                                        name: __costcenters.name,
                                        type: __costcenter.id,
                                      });
                                      _cost_center[__costcenter_i].costCenters[__costcenters_i].editable = false;
                                      setcostCenter(_cost_center);
                                    }}
                                    onKeyDown={ev => {
                                      if (ev.keyCode === 13 || ev.keyCode === 27) {
                                        ev.target.blur();
                                      }
                                    }}
                                  />
                                  <button
                                    type="button"
                                    className="simple-ico mr-2"
                                    onClick={ev => {
                                      ev.stopPropagation();
                                      let _cost_center = [...costCenter];
                                      _cost_center[__costcenter_i].costCenters[__costcenters_i].editable = true;
                                      setcostCenter(_cost_center);
                                    }}
                                  >
                                    {!__costcenters.editable && <IcEditar />}
                                  </button>
                                </label>
                              </div>
                            </Accordion.Header>
                            <Accordion.Body>
                              <Accordion>
                                {__costcenters.expensePlan.map((e3, i3) => (
                                  <Accordion.Item eventKey={`${__costcenter.id}.${__costcenters.id}.${e3.id}`}>
                                    <Accordion.Header
                                      eventKey={!e3.editable ? `${__costcenter.id}.${__costcenters.id}.${e3.id}` : null}
                                      style={e3.editable ? { borderColor: "var(--color-primary" } : {}}
                                    >
                                      <div
                                        className={styleButton.input_button_list}
                                        data-edit={e3.editable}
                                        style={{ border: "none", padding: "0", height: "auto" }}
                                      >
                                        <label style={{ cursor: "pointer" }}>
                                          {__costcenters.id ? (
                                            <span>
                                              {__costcenters_i + 1}.{i3 + 1}
                                            </span>
                                          ) : (
                                            <span></span>
                                          )}
                                          <input
                                            type="text"
                                            placeholder={`Novo Plano de Custo (${__costcenters.name})`}
                                            value={e3.name}
                                            disabled={!e3.editable}
                                            autoFocus
                                            style={!e3.editable ? { pointerEvents: "none" } : {}}
                                            onChange={e3 => {
                                              let _cost_center = [...costCenter];
                                              _cost_center[__costcenter_i].costCenters[__costcenters_i].expensePlan[
                                                i3
                                              ].name = e3.target.value;
                                              setcostCenter(_cost_center);
                                            }}
                                            onBlur={() => {
                                              let _cost_center = [...costCenter];
                                              createExpensePlan({
                                                id: e3.id,
                                                name: e3.name,
                                                cost_center_id: __costcenters.id,
                                              });
                                              _cost_center[__costcenter_i].costCenters[__costcenters_i].expensePlan[
                                                i3
                                              ].editable = false;
                                              setcostCenter(_cost_center);
                                            }}
                                            onKeyDown={ev => {
                                              if (ev.keyCode === 13 || ev.keyCode === 27) {
                                                ev.target.blur();
                                              }
                                            }}
                                          />
                                          <button
                                            type="button"
                                            className="simple-ico mr-2"
                                            onClick={ev => {
                                              ev.stopPropagation();
                                              let _cost_center = [...costCenter];
                                              _cost_center[__costcenter_i].costCenters[__costcenters_i].expensePlan[
                                                i3
                                              ].editable = true;
                                              setcostCenter(_cost_center);
                                            }}
                                          >
                                            {!e3.editable && <IcEditar />}
                                          </button>
                                        </label>
                                      </div>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                      <Row style={{ marginTop: "-1rem" }}>
                                        {e3.expenses.map((e4, i4) => (
                                          <Col sm={6} className="mt-3">
                                            <div className={styleButton.input_button_list} data-edit={e4.editable}>
                                              {e4.id && (
                                                <Accordion.Extras className={`pe-auto mr-2`}>
                                                  <Tooltip2 tip="Custo de Aquisição do Cliente">
                                                    <label style={{ cursor: "pointer" }}>
                                                      <Checkbox
                                                        colorScheme="secondary"
                                                        checked={e4.is_cac}
                                                        onChange={value => {
                                                          let _cost_center = [...costCenter];
                                                          _cost_center[__costcenter_i].costCenters[
                                                            __costcenters_i
                                                          ].expensePlan[i3].expenses[i4].is_cac = value.target.checked;
                                                          setcostCenter(_cost_center);
                                                          createExpense({
                                                            id: e4.id,
                                                            name: e4.name,
                                                            expense_plan_id: e3.id,
                                                            is_cac: value.target.checked,
                                                          });
                                                        }}
                                                      />
                                                      <span className="ml-1">CAC</span>
                                                    </label>
                                                  </Tooltip2>
                                                </Accordion.Extras>
                                              )}
                                              <label>
                                                {e4.id ? (
                                                  <span>
                                                    {__costcenters_i + 1}.{i3 + 1}.{i4 + 1}
                                                  </span>
                                                ) : (
                                                  <span></span>
                                                )}
                                                <input
                                                  type="text"
                                                  placeholder={`Nova ${__costcenter.label} (${e3.name})`}
                                                  value={e4.name}
                                                  disabled={!e4.editable}
                                                  autoFocus
                                                  onChange={ev => {
                                                    let _cost_center = [...costCenter];
                                                    _cost_center[__costcenter_i].costCenters[
                                                      __costcenters_i
                                                    ].expensePlan[i3].expenses[i4].name = ev.target.value;
                                                    setcostCenter(_cost_center);
                                                  }}
                                                  onBlur={() => {
                                                    let _cost_center = [...costCenter];
                                                    createExpense({
                                                      id: e4.id,
                                                      name: e4.name,
                                                      expense_plan_id: e3.id,
                                                      is_cac: e4.is_cac,
                                                    });
                                                    setTimeout(function () {
                                                      _cost_center[__costcenter_i].costCenters[
                                                        __costcenters_i
                                                      ].expensePlan[i3].expenses[i4].editable = false;
                                                      setcostCenter(_cost_center);
                                                    }, 100);
                                                  }}
                                                  onKeyPress={ev => {
                                                    if (ev.charCode === 13) {
                                                      ev.target.blur();
                                                    }
                                                  }}
                                                />
                                                <button
                                                  type="button"
                                                  className="simple-ico"
                                                  onClick={() => {
                                                    let _cost_center = [...costCenter];
                                                    _cost_center[__costcenter_i].costCenters[
                                                      __costcenters_i
                                                    ].expensePlan[i3].expenses[i4].editable = true;
                                                    setcostCenter(_cost_center);
                                                  }}
                                                >
                                                  {!e4.editable && <IcEditar />}
                                                </button>
                                              </label>
                                            </div>
                                          </Col>
                                        ))}
                                        <Col sm={12}>
                                          <button
                                            className={`mt-3 ${styleButton.button_add}`}
                                            colorScheme="grey"
                                            type="button"
                                            onClick={() => {
                                              let _cost_center = [...costCenter];
                                              _cost_center[__costcenter_i].costCenters[__costcenters_i].expensePlan[
                                                i3
                                              ].expenses.push({
                                                editable: true,
                                                id: null,
                                                is_cac: 0,
                                                name: "",
                                              });
                                              setcostCenter(_cost_center);
                                            }}
                                          >
                                            <span>Adicionar Conta ({e3.name})</span>
                                          </button>
                                        </Col>
                                      </Row>
                                    </Accordion.Body>
                                  </Accordion.Item>
                                ))}
                              </Accordion>
                              <button
                                className={`mt-3 ${styleButton.button_add}`}
                                colorScheme="secondary"
                                type="button"
                                onClick={() => {
                                  let _cost_center = [...costCenter];
                                  _cost_center[__costcenter_i].costCenters[__costcenters_i].expensePlan.push({
                                    editable: true,
                                    id: null,
                                    name: "",
                                    expenses: [],
                                  });
                                  setcostCenter(_cost_center);
                                }}
                              >
                                <span>Adicionar Plano de Conta ({__costcenters.name})</span>
                              </button>
                            </Accordion.Body>
                          </Accordion.Item>
                        ))}
                      </Accordion>
                    </TabNotification.Body>
                    <button
                      className={`mt-3 ${styleButton.button_add}`}
                      type="button"
                      colorScheme="primary"
                      onClick={() => {
                        let _cost_center = [...costCenter];
                        _cost_center[__costcenter_i].costCenters.push({
                          editable: true,
                          id: null,
                          name: "",
                          expensePlan: [],
                          type: __costcenter.id,
                        });
                        console.log(" _cost_center", _cost_center);
                        setcostCenter(_cost_center);
                      }}
                    >
                      <span>Adicionar Centro de Custo ({__costcenter.label})</span>
                    </button>
                  </>
                )}
              </>
            ))}
          </Content>
        </Main>
      )}
    </>
  );
}
